module.exports = __webpack_public_path__ + "static/media/revision_history_icon.ddd6138d.svg";